import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { ApiService } from '../../../services/api.service';
import { Router } from '@angular/router';
@Component({
  selector: 'app-receivable-control',
  templateUrl: './receivable-control.component.html',
  styleUrls: ['./receivable-control.component.css']
})
export class ReceivableControlComponent implements OnInit {

  data_all = [] as any;
  data_funding = [] as any;
  years = [] as any;
  types = ['เงินให้กู้ยืม', 'เงินสนับสนุน', 'เงินอุดหนุน', 'เงินทดรองจ่าย', 'ทั้งหมด']
  searchForm!: FormGroup;

  page = 1;
  count = 0;
  tableSize = 20;

  constructor(
    public services: ApiService,
    public formBuilder: FormBuilder,
    public router: Router
  ) { }

  ngOnInit(): void {
    document.getElementById('receivables')!.classList.toggle("active");
    document.getElementById('receivable')!.classList.toggle("show");
    document.getElementById('control')!.classList.toggle("active");

    this.getAllData();
    this.searchForm = this.formBuilder.group({
      type: '',
      year: ''
    });
  }

  ngOnDestroy() {
    document.getElementById('receivables')!.classList.remove("active");
    document.getElementById('receivable')!.classList.remove("show");
    document.getElementById('control')!.classList.remove("active");
  }

  async getAllData() {
    let all_debt: any
    this.years = ['ทั้งหมด'] as any;
    await this.services.get("m_receivabledetail").then((res: any) => {
      all_debt = res.filter((data: any) => {
        return data.status.toLowerCase().match('enable')
      })
    });
    await this.services.get('funding').then(async (res: any) => {
      await res.forEach((data: any) => {
        if (data.status == "Enable") {
          // all_debt.forEach((e: any) => {
          //   if (e.project_key) {
          //     if ((e.project_key).toLowerCase() == data.project_key.toLowerCase()) {
          //       data.debt_id = Number(e.debt_id)
          //     }
          //   } else {
          //     if (e.project_key == data.project_key) {
          //       data.debt_id = 0
          //     }
          //   }
          // });
          let debt = all_debt.find((f:any)=>{
            if(f.project_key){
            return f.project_key.toLowerCase() == data.project_key.toLowerCase()
            }else{
              return undefined
            }
          })
          if(debt){
            data.debt_id = Number(debt.debt_id)
          }else{
            data.debt_id = 0
          }
          
          this.years.push((data.fund_year))
          this.data_all.push(data);
          this.data_funding.push(data);
        }

      });
    })
    this.data_all = this.data_all.sort((a:any,b:any) => (a.debt_id > b.debt_id) ? -1 : ((b.debt_id > a.debt_id) ? 1 : 0))
    
    this.years = [...new Set(this.years)].sort();
    this.onClickSearch('all')
  }

  async onClickSearch(type: any) {
    if (type == 'search') {
      this.page = 1
      this.data_funding = [] as any;
      this.data_funding = this.data_all.filter((res: any) => {
        return res.project_name.match(this.searchForm.value.type)
      })
    }
    this.data_funding = this.data_funding.sort((a:any,b:any) => (a.debt_id > b.debt_id) ? -1 : ((b.debt_id > a.debt_id) ? 1 : 0))
  }

  onTableDataChange(event: any) {
    this.page = event;
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  }

  onClickView(data: any) {
    localStorage.setItem("debt", JSON.stringify(data))
    this.router.navigate(['receivables/detail'])
  }
  clickMenu() {
    document.getElementById('sidebar')!.classList.toggle("active");
  }
  onClickListMenu() {
    document.getElementById('finances')!.classList.remove('active');
    document.getElementById('finance')!.classList.remove('show');
    document.getElementById('plans')!.classList.remove('active');
    document.getElementById('plan')!.classList.remove('show');
    // document.getElementById('receivables')!.classList.remove('active');
    document.getElementById('receivable')!.classList.remove('show');
  }

}
